export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20minimalist%20abstract%20background%20with%20soft%20golden%20amber%20and%20cream%20gradients%2C%20smooth%20flowing%20curves%2C%20modern%20tech%20atmosphere%2C%20subtle%20geometric%20patterns%2C%20clean%20and%20elegant%20composition%2C%20bright%20airy%20feeling%2C%20gentle%20light%20rays%2C%20premium%20quality&width=1920&height=900&seq=hero-bg-kuaimao&orientation=landscape"
          alt="快猫app背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-8">
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
          <span className="text-sm text-background-50 font-medium">V3.5.0 全新版本已发布</span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight mb-6">
          探索无限可能
          <br />
          <span className="text-accent-400">快猫app</span> 全新体验
        </h1>

        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          快猫app是一款集智能推荐、多端同步、隐私安全于一体的综合性移动应用。
          无论你是新用户还是老用户，都能在这里找到属于你的精彩。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#download"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
          >
            <i className="ri-download-cloud-2-line mr-2"></i>
            立即下载
          </a>
          <a
            href="#features"
            className="px-8 py-3.5 rounded-full bg-background-50/15 backdrop-blur-sm text-background-50 text-base font-semibold hover:bg-background-50/25 transition-all duration-200 whitespace-nowrap cursor-pointer border border-background-50/20"
          >
            <i className="ri-arrow-down-line mr-2"></i>
            了解更多
          </a>
        </div>

        <div className="mt-12 flex items-center justify-center gap-8 text-background-50/60">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50">500万+</div>
            <div className="text-xs md:text-sm mt-1">活跃用户</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50">4.9</div>
            <div className="text-xs md:text-sm mt-1">用户评分</div>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50">99.9%</div>
            <div className="text-xs md:text-sm mt-1">服务可用率</div>
          </div>
        </div>
      </div>
    </section>
  );
}